import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  condicionPago: Yup.string().required(),
  moneda: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  serieDocumento: Yup.string().length(4).required(),
  numeroDocumento: Yup.string().when('flagSerieContingencia', {
    is: true,
    then: Yup.string().max(8).required()
  })
})
